import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../../common/services/Login.service';
import { SessionService } from '../../common/services/Session.service';

interface PageList {
  item: string;
  itemLink?: string;
  itemData?: PageList[];
}

@Component({
  selector: 'app-pdfbackup-landing-page',
  templateUrl: './pdfbackup-landing-page.component.html',
  styleUrls: ['./pdfbackup-landing-page.component.css']
})
export class PDFBackupLandingPageComponent implements OnInit {

  @ViewChild('tree') tree;
  treeControl = new NestedTreeControl<PageList>(node => node.itemData);
  dataSource = new MatTreeNestedDataSource<PageList>();
  treeRendered = false;
  public aFormGroup: FormGroup;
  public FormGroup: FormGroup;
  siteKey: string = "";
  usageText: any;
  loadpagecontent: boolean = false;
  additionalInfo: any;
  contactFASBSupport: any;
  isCaptchaVerified = false;
  isAccessSucess = false;
  accessPdfViewButton: any;
  showcaptchaView: boolean = true;
  rightPanelDescription: any;
  Termandcondition: any;
  isproviewuser = false;
  constructor(public commonDataService: CommonDataService, private _loginservice: LoginService,
    private graphQlService: GraphqlService, private router: Router, private formBuilder: FormBuilder, private session: SessionService,) {
  }

  hasChild = (_: number, node: PageList) => !!node.itemData && node.itemData != null;

  ngOnInit(): void {
    this.isproviewuser = this.session?.userInfo?.user?.roles == "Professional";
    this.aFormGroup = this.formBuilder.group({
      recaptcha: ['', Validators.required]
    });
    this.FormGroup = this.formBuilder.group({
      recaptchaProf: ['', Validators.required]
    });
    this.commonDataService.showLoader.next(true);
    forkJoin([this.graphQlService.getPDFBackupLandingPageLabels(), this.isproviewuser ? this.graphQlService.GetPDFBackupPageListForProViewAsync() : this.graphQlService.GetPDFBackupPageListAsync() , this.graphQlService.getSiteKey()])
      .subscribe(([labelData, pageList, siteKey]) => {
      var labels = labelData.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.siteKey = siteKey.result;
      this.header = labels.filter(x => x.key == "header").map(y => y.value);
      this.content = labels.filter(x => x.key == "content").map(y => y.value);
        this.Termandcondition = labels.filter(x => x.key == "pdf_licenseeAgreement").map(y => y.value);
        this.accessPdfViewButton = labels.filter(x => x.key == "pdf_accessButton").map(y => y.value);
        this.usageText = labels.filter(x => x.key == "pdf_usageText").map(y => y.value);
        this.additionalInfo = labels.filter(x => x.key == "pdf_additionalInfo").map(y => y.value);
        this.contactFASBSupport = labels.filter(x => x.key == "pdf_contactFASBSupport").map(y => y.value);
      this.pdfBackupPageList = pageList;
      this.dataSource.data = this.pdfBackupPageList;
      this.treeControl.dataNodes = this.pdfBackupPageList;
      this.treeControl.expandAll();
      this.treeRendered = true;
      this.commonDataService.showLoader.next(false);
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  header: string = "";
  content: string = "";
  pdfBackupPageList: any = [];

  getPDFBackupLandingPagelabels() {
    this.graphQlService.getPDFBackupLandingPageLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.header = labels.filter(x => x.key == "header").map(y => y.value);
        this.content = labels.filter(x => x.key == "content").map(y => y.value);

      }
    }, err => {
      console.log(err);
    });
  }
  getPDFBackupPageList() {
    if (this.isproviewuser) {
      this.graphQlService.GetPDFBackupPageListForProViewAsync().subscribe(data => {
        if (data != null) {
          this.pdfBackupPageList = data;
          this.dataSource.data = this.pdfBackupPageList;
          this.treeControl.dataNodes = this.pdfBackupPageList;
          this.treeControl.expandAll();
          this.treeRendered = true;
          this.commonDataService.showLoader.next(false);
        }
      }, err => {
        console.log(err);
        this.commonDataService.showLoader.next(false);
      });
    }
    else {
      this.graphQlService.GetPDFBackupPageListAsync().subscribe(data => {
        if (data != null) {
          this.pdfBackupPageList = data;
          this.dataSource.data = this.pdfBackupPageList;
          this.treeControl.dataNodes = this.pdfBackupPageList;
          this.treeControl.expandAll();
          this.treeRendered = true;
          this.commonDataService.showLoader.next(false);
        }
      }, err => {
        console.log(err);
        this.commonDataService.showLoader.next(false);
      });
    }
  }

  navigateToUrl(id: string) {
    let pdfURL = '/layoutComponents/getPdf?isSitesBucket=false&isPDFBackup=true&fileName=' + id;
    window.open(pdfURL);
  }

  captchaToken: string = "";
  onCaptchaSuccess(token: string) {
    this.captchaToken = token;
    this._loginservice.verifyReCaptcha(this.captchaToken).subscribe(data => {
      if (data) {
    document.getElementById("btnPdfView").removeAttribute("disabled");
    document.getElementById("btnPdfView").classList.remove("btn-secondary-disabled-basic");
    document.getElementById("btnPdfView").classList.add("btn-primary-professional", "cursor-pointer");
    this.isCaptchaVerified = true;
        sessionStorage.setItem('captchaVerified', 'true');
      }
      else { this.router.navigateByUrl("/Login"); }
    });
  }
  onCaptchaError() {
    this.captchaToken = "";
    document.getElementById("btnPdfView").setAttribute("disabled", "true");
    document.getElementById("btnPdfView").classList.add("btn-secondary-disabled-basic");
    document.getElementById("btnPdfView").classList.remove("btn-primary-professional", "cursor-pointer");
    this.isCaptchaVerified = false;
  }
 
  accessPdfView() {
    if (this.isCaptchaVerified = true) {
      this.isAccessSucess = true;
    }
    else {
      this.isAccessSucess = false;
    }
    this.showcaptchaView = false;
  }
 
}
